export const jsonSchema = {
  title: 'Login',
  description: '',
  type: 'object',
  properties: {
    email: {
      type: 'string',
      title: 'Email',
      format: 'email'
    },
    password: {
      type: 'string',
      title: 'Password'
    }
  }
};

export const jsonUiSchema = {
    password: {
        'ui:widget': 'password'
    }
};



/** WEBPACK FOOTER **
 ** ./src/Login/schema.js
 **/